import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { getSettings } from "../api";

export default function WhatsAppButton() {
  const [s, setS] = useState({});
  useEffect(() => { getSettings().then(setS); }, []);

  const number = (s.whatsapp || "+919999999999").replace(/[^0-9+]/g, "");
  const message = encodeURIComponent(s.whatsapp_message || "Hello, I'm interested in SSC Ready Mix concrete.");
  const href = s.social_whatsapp_url || `https://api.whatsapp.com/send?phone=${number}&text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-floating-btn"
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-2.5 bg-[#ef2435] hover:bg-[#c41822] text-white pl-3.5 pr-5 py-3 rounded-full shadow-2xl shadow-[#ef2435]/30 transition-all hover:-translate-y-0.5"
      aria-label="WhatsApp"
    >
      <span className="relative">
        <MessageCircle size={20} className="fill-white"/>
        <span className="absolute inset-0 rounded-full bg-white/40 pulse-red"/>
      </span>
      <span className="text-xs font-semibold uppercase tracking-wider hidden sm:inline">Chat with us</span>
    </a>
  );
}
